module.exports = __webpack_public_path__ + "media/images/logo-0dc747ff.svg";